import React from 'react';
// "Publication Details Few slots left"
const ThirdStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    registration_link,
    paper_title,
    journals,
    isbn_number,
    your_name,
    contact_details,

    // your_title,
    // your_contact_information,
    // your_website,
  } = values;
  return (
    <div>
      <p>{client_name ? `Dear ${client_name},` : ` Dear [Author's Name],`}</p>

      <p>
        We are pleased to inform you that your paper, “
        {paper_title ? paper_title : `[Paper Title]`}”, has been{' '}
        <strong>accepted for publication</strong> in one of the{' '}
        <strong>
          prestigious Scopus/Web of Science (WoS) indexed journals
        </strong>{' '}
        as part of the upcoming{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : '[Conference Short Name]'}
        </strong>
        , scheduled to take place from{' '}
        <strong>
          {conference_from_date && conference_to_date
            ? `${conference_from_date} - ${conference_to_date}`
            : `[Conference from and to Date]`}
        </strong>{' '}
        at{' '}
        <strong>
          {conference_location ? conference_location : '[Conference Venue]'}
        </strong>
        .
      </p>

      <p>
        Your research will be considered for publication in one of the following
        esteemed journals:
      </p>

      <ul>
        {journals && journals.length > 0 ? (
          journals.map((elem, index) => {
            const { journal_name } = elem;
            return (
              <li key={index}>
                {journal_name ? journal_name : `[Journal Name ${index + 1}]`}
              </li>
            );
          })
        ) : (
          <>
            <li>[Journal Name 1]</li>
            <li>[Journal Name 2]</li>
            <li>[Journal Name 3]</li>
          </>
        )}
      </ul>

      <p>
        Additionally, your work will be featured in the conference proceedings
        with a registered{' '}
        <strong>
          ISBN number: {isbn_number ? isbn_number : `[ISBN Number]`}
        </strong>
        , further enhancing the global visibility and academic recognition of
        your contribution.
      </p>

      <p>
        <div>
          <strong>Why This Matters:</strong>
        </div>
        <strong>🔹Academic Recognition</strong>: Get your work published in
        high-impact journals
        <br />
        <strong>🔹Global Exposure</strong>: Expand your reach within the
        international research community
        <br />
        <strong>🔹Professional Advancement</strong>: Strengthen your academic
        and professional portfolio
      </p>

      <p>
        We’re excited about the impact your research will make and look forward
        to your continued participation in the conference and the global
        academic community.
      </p>
      <p>
        Should you need any assistance regarding registration, feel free to
        reach out.
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default ThirdStepTemplate;
